// extracted by mini-css-extract-plugin
export default {"empty-placeholder":"styles_empty-placeholder__m7ez-"};